import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState as addressManagerState } from "./AddressState";
import { IState } from "slices";
import { AddressDetailsModel } from "app/data/address-manager/models";

export const addressSlice = createSlice({
    name: "address",
    initialState: addressManagerState,
    reducers: {
        loading: (state, action: PayloadAction<{ type: "list" | "byId", isLoading: boolean }>) => {
            state.list.isLoading = action.payload.type === "list" ? action.payload.isLoading : state.list.isLoading;
            state.byId.isLoading = action.payload.type === "byId" ? action.payload.isLoading : state.byId.isLoading;
        },
        setAddressList: (state, action: PayloadAction<{ data: any[]; count: number }>) => {
            state.list.isLoading = false;
            state.list.isSuccess = true;
            state.data = action.payload.data;
            state.resultCount = action.payload.count;
        },
        setAddressById: (state, action: PayloadAction<{ id: string; address: AddressDetailsModel }>) => {
            state.selectedAddressId = action.payload.id;
            state.selectedAddress = action.payload.address;
            state.byId.isLoading = false;
            state.byId.isSuccess = true;
        },
        setSearchString: (state, action: PayloadAction<{ searchString: string }>) => {
            state.searchString = action.payload.searchString;
        }
    },
});

export const {
    loading,
    setAddressList,
    setAddressById,
    setSearchString
} = addressSlice.actions;

export const addressSelector = (state: IState) => state.address;

const addressReducer = addressSlice.reducer;
export default addressReducer;
